import React, { useState } from 'react'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  display: inline-block;
  margin-left: 4px;
  position: relative;
`

const StyledIcon = styled.img.attrs(props => ({
  src: props.src,
  alt: props.alt,
}))``

const StyledTooltip = styled.div`
  align-items: center;
  background-color: #4e5d78;
  border-radius: 4px;
  bottom: calc(100% + 7px);
  color: #c9ced6;
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  flex-direction: column;
  font-size: 12px;
  font-weight: 500;
  justify-content: flex-start;
  left: 50%;
  margin-left: -100px;
  padding: 4px 8px;
  position: absolute;
  width: 200px;
  z-index: 2;

  :after {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 6px solid #4e5d78;
    bottom: -6px;
    box-sizing: border-box;
    content: '';
    height: 0;
    left: 50%;
    margin-left: -4px;
    position: absolute;
    width: 0;
  }

  h6 {
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
  }

  p {
    color: #c9ced6;
    text-align: center;
  }

  span {
    color: ${({ theme }) => theme.colors.white};
  }

  table {
    max-width: 100%;
    overflow: hidden;
    width: 100%;

    thead {
      border-bottom: 1px solid #c9ced6;

      th {
        font-weight: 400;
        padding: 4px 0;

        :first-of-type {
          text-align: left;
        }

        :last-of-type {
          text-align: right;
        }
      }
    }

    tbody,
    tfoot {
      td {
        max-width: 0;
        overflow: hidden;
        padding: 2px 5px 2px 0;
        text-overflow: ellipsis;
        white-space: nowrap;
        z-index: 1;

        :first-of-type {
          text-align: left;
          width: 134px;
        }

        :last-of-type {
          padding-right: 0;
          text-align: right;
          width: 50px;
        }
      }

      tr:first-of-type {
        td {
          padding-top: 4px;
        }
      }

      tr:last-of-type {
        td {
          padding-bottom: 4px;
        }
      }
    }

    tfoot {
      border-top: 1px solid #c9ced6;
    }
  }
`

const Tooltip = ({ children }) => {
  const [visible, setVisible] = useState(false)
  return (
    <StyledWrapper
      onMouseOver={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <StyledIcon alt="info" src={require(`../../../assets/svg/info.svg`)} />
      <StyledTooltip visible={visible}>{children}</StyledTooltip>
    </StyledWrapper>
  )
}

export default Tooltip
